import {
  Album,
  getDerivedAlbumTrack,
  isDerivedAlbum,
} from '@app/web-player/albums/album';
import {AlbumImage} from '@app/web-player/albums/album-image/album-image';
import {ArtistLinks} from '@app/web-player/artists/artist-links';
import {PlayableGridItem} from '@app/web-player/playable-item/playable-grid-item';
import {AlbumLink, getAlbumLink} from '@app/web-player/albums/album-link';
import {AlbumContextDialog} from '@app/web-player/albums/album-context-dialog';
import {LikeIconButton} from '@app/web-player/library/like-icon-button';
import {AlbumPage} from '@app/web-player/albums/album-page';
import {TrackContextDialog} from '@app/web-player/tracks/context-dialog/track-context-dialog';

interface AlbumGridItemProps {
  album: Album;
  contentFormat?: string;
}
export function AlbumGridItem({album, contentFormat}: AlbumGridItemProps) {
  const derivedTrack = getDerivedAlbumTrack(album);
  const likeable =
    isDerivedAlbum(album) && derivedTrack ? derivedTrack : album;
  const contextDialog =
    isDerivedAlbum(album) && derivedTrack ? (
      <TrackContextDialog tracks={[derivedTrack]} />
    ) : (
      <AlbumContextDialog album={album} />
    );

  return (
    <PlayableGridItem
      item={<AlbumPage album={album} />}
      image={<AlbumImage album={album} contentFormat={contentFormat} />}
      title={<AlbumLink album={album} />}
      titleDialog={album.name}
      subtitle={<ArtistLinks artists={album.artists} onlyPrimaryArtist={true} showMoreArtists={true}/>}
      link={getAlbumLink(album)}
      newQueue={album.tracks}
      likeButton={<LikeIconButton likeable={likeable} />}
      model={album}
      contextDialog={contextDialog}
      contentFormat={contentFormat}
    />
  );
}
